"use client";

// Filterkopf der Spendenliste — aus dem Listen-Baukasten
// (`components/liste`), Aufbau wie bei den Mitgliedern:
// oben Suche · Jahr · Art, unten Aufruf · ohne Bestätigung.
import { Megaphone } from "lucide-react";
import {
  Auswahlfeld,
  Filterkopf,
  Filterzurueck,
  Fuge,
  Luecke,
  Schiene,
  Suchfeld,
  useAnsicht,
  Zaehlknopf,
  Zaehlschiene,
  type Auswahl,
} from "@/components/liste";
import { ARTEN, SPENDEN_PARAMS, spendenFilterAnzahl, type SpendenAnsicht } from "@/lib/spenden/ansicht";

export function SpendenFilterkopf({
  ansicht,
  laufendesJahr,
  jahre,
  arten,
  aufrufe,
  ohneBestaetigung,
}: {
  ansicht: SpendenAnsicht;
  laufendesJahr: number;
  jahre: { jahr: string; anzahl: number }[];
  arten: Record<string, number>;
  aufrufe: Auswahl[];
  ohneBestaetigung: number;
}) {
  const { setzen, isPending } = useAnsicht();
  const jahrGewaehlt = ansicht.jahr || String(laufendesJahr);

  return (
    <Filterkopf
      isPending={isPending}
      oben={
        <>
          <Suchfeld wert={ansicht.q} platzhalter="Spender, Zweck, Betrag …" beschriftung="Spenden durchsuchen" />
          <Luecke />
          <Zaehlschiene titel="Jahr">
            {jahre.map((j) => (
              <span key={j.jahr} className="contents">
                {j.jahr === "alle" && <Fuge />}
                <Zaehlknopf
                  label={j.jahr === "alle" ? "Alle Jahre" : j.jahr}
                  anzahl={j.anzahl}
                  aktiv={jahrGewaehlt === j.jahr}
                  sammel={j.jahr === "alle"}
                  onClick={() => setzen({ jahr: j.jahr === String(laufendesJahr) ? null : j.jahr })}
                />
              </span>
            ))}
          </Zaehlschiene>
          <Zaehlschiene titel="Art">
            {ARTEN.map((a) => (
              <Zaehlknopf
                key={a.schluessel}
                label={a.label}
                anzahl={arten[a.schluessel] ?? 0}
                aktiv={ansicht.art === a.schluessel}
                titel={a.hinweis}
                onClick={() => setzen({ art: ansicht.art === a.schluessel ? null : a.schluessel })}
              />
            ))}
          </Zaehlschiene>
        </>
      }
      unten={
        <>
          <Auswahlfeld
            icon={Megaphone}
            titel="Aufruf"
            label="Aufruf"
            eintraege={aufrufe}
            gewaehlt={ansicht.aufruf}
            onWaehlen={(id) => setzen({ aufruf: id })}
            suchtext="Aufruf suchen …"
            alleLabel="Alle Spenden"
            leerText="Kein Aufruf gefunden"
          />
          <Schiene>
            <Zaehlknopf
              label="Ohne Bestätigung"
              anzahl={ohneBestaetigung}
              aktiv={ansicht.bestaetigung === "ohne"}
              titel="Spenden bekannter Personen, für die noch keine Zuwendungsbestätigung ausgestellt ist"
              onClick={() => setzen({ bestaetigung: ansicht.bestaetigung === "ohne" ? null : "ohne" })}
            />
          </Schiene>
          <Luecke />
          <Filterzurueck anzahl={spendenFilterAnzahl(ansicht)} params={SPENDEN_PARAMS} />
        </>
      }
    />
  );
}
